import * as React from 'react';
import { connect } from 'react-redux';

import numeral from 'numeral';

import {
  createStyles,
  Slider,
  Tooltip,
  WithStyles,
  withStyles
} from '@material-ui/core';

import { IFilterState, IMapFilters, IStore } from '@reducers';

const styles = () =>
  createStyles({
    control: {
      width: '100%'
    }
  });

interface IProps {
  variant: 'dollars' | 'number';
  storeKey: string;
  unsavedFilters: IMapFilters;
  setUnsavedFilters(filters: IMapFilters);
}

const ValueLabelComponent: React.FC<{
  children: React.ReactElement;
  open: boolean;
  value: number;
}> = ({ children, open, value }) => (
  <Tooltip open={open} placement="top" title={value}>
    {children}
  </Tooltip>
);

const FilterSlider: React.FC<IFilterState &
  WithStyles<typeof styles> &
  IProps> = ({
  classes,
  setUnsavedFilters,
  unsavedFilters,
  filters,
  storeKey,
  variant
}) => {
  const onUnsavedFiltersSliderChange = (key: string) => (
    _e: React.ChangeEvent<{}>,
    value: number | number[]
  ) => {
    if (typeof value === 'number') {
      return false;
    }

    return setUnsavedFilters({
      ...unsavedFilters,
      [key]: {
        ...unsavedFilters[key],
        user: {
          min: value[0],
          max: value[1]
        }
      }
    });
  };

  return (
    <Slider
      className={classes.control}
      id={`${storeKey}-slider`}
      valueLabelDisplay="auto"
      aria-labelledby={`${storeKey}-slider`}
      min={filters[storeKey].bounds.minMax.min}
      max={filters[storeKey].bounds.minMax.max}
      value={[
        unsavedFilters[storeKey].user.min,
        unsavedFilters[storeKey].user.max
      ]}
      marks={filters[storeKey].bounds.marks}
      onChange={onUnsavedFiltersSliderChange(storeKey)}
      step={filters[storeKey].bounds.step}
      valueLabelFormat={(value) =>
        `${
          variant === 'dollars'
            ? (value >= 1000 && value < 10000) ||
              (value >= 1000000 && value < 10000000)
              ? numeral(value).format('$0,0.0a')
              : numeral(value).format('$0,0a')
            : numeral(value).format('0,0a')
        }${
          value === filters[storeKey].bounds.minMax.min
            ? ' or lower'
            : value === filters[storeKey].bounds.minMax.max
            ? ' or higher'
            : ''
        }`
      }
      ValueLabelComponent={ValueLabelComponent}
    />
  );
};

export default withStyles(styles)(
  connect((state: IStore): IFilterState => state.filter)(FilterSlider)
);
